import type { GetNotariesQueryParams, NotaryApi } from '@izimi/api';
import type { FirstParameter } from '@izimi/utils';

class NotaryQueryKeys {
  constructor(private prefix: string) {}

  getPreferredNotary() {
    return [this.prefix, 'preferred'];
  }

  getNotaries(queryParams?: GetNotariesQueryParams) {
    return [this.prefix, 'notaries', queryParams];
  }

  getNotary(notaryId: string) {
    return [this.prefix, 'notary', notaryId];
  }

  getNotaryClaimedVault(nrn: string) {
    return [this.prefix, 'notary', 'claimed-vault', nrn];
  }

  getNotaryClaimedVaults(params: FirstParameter<NotaryApi['getClaimedVaults']>) {
    return [this.prefix, 'notary', 'claimed-vaults', params];
  }

  getClaimedVaultHistory(claimedVaultId: string) {
    return [this.prefix, 'notary', 'claimed-vault', 'history', claimedVaultId];
  }

  claimableVault(nrn: string) {
    return [this.prefix, 'notary', 'claimable-vault', nrn];
  }

  getNotaryHeirs(params: FirstParameter<NotaryApi['getHeirs']>) {
    return [this.prefix, 'notary', 'heirs', params];
  }

  getVaultOwner(params: FirstParameter<NotaryApi['getVaultOwner']>) {
    return [this.prefix, 'notary', 'vault-owner', params];
  }

  getNotaryContacts(params: FirstParameter<NotaryApi['getNotaryContacts']>) {
    return [this.prefix, 'notary', 'contacts', params];
  }

  getNotaryContact(contactId: string) {
    return [this.prefix, 'notary', 'contact', contactId];
  }

  getNotaryDocuments(params: FirstParameter<NotaryApi['getNotaryDocuments']>) {
    return [this.prefix, 'notary', 'documents', params];
  }

  getNotaryDocument(documentId: string) {
    return [this.prefix, 'notary', 'document', documentId];
  }

  getNotaryMailConfiguration() {
    return [this.prefix, 'notary', 'mail-configuration'];
  }
}

export default NotaryQueryKeys;
